import React from 'react'
import '../../../node_modules/normalize.css/normalize.css'
import '../../css/global.css'

const styles = {
  div: {
    display: 'flex',
    justifyContent: 'center',
  },
}

const Layout = ({ children }) => <div style={styles.div}>{children}</div>

export { Layout }
